export const FETCH_WAREHOUSELIST_INIT_ACTION = "FETCH_WAREHOUSELIST_INIT_ACTION";
export const FETCH_WAREHOUSELIST_SUCCESS_ACTION = FETCH_WAREHOUSELIST_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSELIST_FAIL_ACTION = FETCH_WAREHOUSELIST_INIT_ACTION + "_ERROR";

export const FETCH_WAREHOUSEBYID_INIT_ACTION = "FETCH_WAREHOUSEBYID_INIT_ACTION";
export const FETCH_WAREHOUSEBYID_SUCCESS_ACTION = FETCH_WAREHOUSEBYID_INIT_ACTION + "_SUCCESS";
export const FETCH_WAREHOUSEBYID_FAIL_ACTION = FETCH_WAREHOUSEBYID_INIT_ACTION + "_ERROR";